<div [ngClass]="props.isAutoComplete ? 'autocomplete' : props.isSwitchInput === true ? 'form-check form-switch' : ''"
     *ngIf="!props.propIsHidden">
    <label class="mt-2">{{ props.label }} <span *ngIf="props.required">*</span></label>

    <div *ngFor="let option of props.options" class="custom-control custom-checkbox custom-checkbox-inter">
        <ng-container *ngIf="props.isMultiSelect; else singleSelect">
            <input class="custom-control-input" 
                   [ngClass]="props.readOnly ? 'checkbox-disabled' : ''" 
                   type="checkbox" 
                   [value]="option.value" 
                   [id]="option.id"
                   [checked]="option.selected" 
                   (change)="checkboxEmitter($event, option)" />
        </ng-container>
        <ng-template #singleSelect>
            <input class="custom-control-input" 
                   [ngClass]="props.readOnly ? 'checkbox-disabled' : ''" 
                   type="radio" 
                   [value]="option.value"
                   [id]="option.id" 
                   formControlName="{{ props.field_Name }}" 
                   (change)="checkboxEmitter(option)" />
        </ng-template>
        <label class="custom-control-label" [for]="option.id">{{ option.label }}</label>
    </div>

    <div class="error-container">
        <sm-error [control]="formcontrol" [label]="'Option'"></sm-error>
    </div>

</div>
